import React from 'react'

export default function PaymentsPopup() {
  return (
    <div>
        
    </div>
  )
}
